// @flow
import LazyLoad from 'react-lazyload';
import { LAZY_LOAD_OFFSET } from 'utils/theme';
import Link from '../Link';
import type { BlokComponentPropsType, LinkedImageType } from '../types';
import Image from '../Image';

const LinkedImage = ({ blok }: BlokComponentPropsType<LinkedImageType>) => {
  // $FlowFixMe ImageBlock causes a weird irreparable type conflict
  const { image, link, alt } = blok;
  return (
    <Link
      link={link}
      gaReference={`Linked Image; ${alt || link.cached_url || link.url}`}
    >
      <LazyLoad offset={LAZY_LOAD_OFFSET}>
        <Image src={image} alt={alt || link} />
      </LazyLoad>
    </Link>
  );
};

export default LinkedImage;
